import { compoundSortAscending, sortByAscending, valuesOfRecord } from 'osn-shared';
import { MpxEpisodeContentResponse, MpxSeasonContentResponse, MpxSeriesContentResponse } from './mpx-program-response';

export class MpxSeries {
  public readonly series: MpxSeriesContentResponse;
  public readonly seasons: MpxSeasonContentResponse[];
  public readonly seasonsWithEpisodes: MpxSeasonContentResponse[];
  public readonly allEpisodes: MpxEpisodeContentResponse[];
  public readonly episodesBySeasonNumber: Record<number, MpxEpisodeContentResponse[]>;
  public readonly iterableSeasonList: MpxEpisodeContentResponse[][];
  public readonly seasonsBySeasonGuid: Record<string, MpxSeasonContentResponse>;
  public readonly episodesBySeasonGuid: Record<string, MpxEpisodeContentResponse[]>;
  public readonly episodesByEpisodeGuid: Record<string, MpxEpisodeContentResponse>;
  public readonly seasonByEpisodeGuid: Record<string, MpxSeasonContentResponse>;

  constructor(series: MpxSeriesContentResponse, seasons: MpxSeasonContentResponse[], episodes: MpxEpisodeContentResponse[]) {
    this.series = series;
    this.seasons = sortByAscending(seasons, (it) => it.tvSeasonNumber);
    this.allEpisodes = compoundSortAscending(episodes, (a, b) => [
      a.tvSeasonNumber - b.tvSeasonNumber,
      a.tvSeasonEpisodeNumber - b.tvSeasonEpisodeNumber,
    ]);

    this.episodesBySeasonNumber = this.allEpisodes.groupByToRecord((it) => it.tvSeasonNumber);

    this.seasonsBySeasonGuid = {};
    this.episodesBySeasonGuid = {};
    this.seasonByEpisodeGuid = {};

    this.seasons.forEach((season) => {
      if (!(season.tvSeasonNumber in this.episodesBySeasonNumber)) {
        this.episodesBySeasonNumber[season.tvSeasonNumber] = [];
      }
      this.seasonsBySeasonGuid[season.guid] = season;
      this.episodesBySeasonGuid[season.guid] = this.episodesBySeasonNumber[season.tvSeasonNumber].slice();

      this.episodesBySeasonNumber[season.tvSeasonNumber].forEach((it) => (this.seasonByEpisodeGuid[it.guid] = season));
    });

    this.seasonsWithEpisodes = this.seasons.filter((it) => this.episodesBySeasonNumber[it.tvSeasonNumber].anyItems());

    this.iterableSeasonList = valuesOfRecord(this.episodesBySeasonNumber);

    this.episodesByEpisodeGuid = {};
    this.allEpisodes.forEach((episode) => (this.episodesByEpisodeGuid[episode.guid] = episode));
  }
}
